import { useEffect, useState } from "react";

export const useDeviceType = (defaultDeviceType = "mobile") => {
  const [deviceType, setDeviceType] = useState(defaultDeviceType);

  const determineDeviceType = () => {
    const width = window.innerWidth;
    if (width <= 1159) {
      setDeviceType("mobile");
    } else {
      setDeviceType("desktop");
    }
  };

  useEffect(() => {
    determineDeviceType();
    window.addEventListener("resize", determineDeviceType);
    return () => {
      window.removeEventListener("resize", determineDeviceType);
    };
  }, []);

  return deviceType;
};
